import { Avatar, Button, Modal, Tag, Timeline } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import GetPositionTimelineApi from "../../../api/positions/GetPositionTimelineApi";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

function PositionTimelineModal(props) {
  const [data, setData] = useState();

  useEffect(() => {
    getTimelineData();
  }, [props.visible]);

  async function getTimelineData() {
    const apiResponse = await GetPositionTimelineApi(props.position?.id);
    if (apiResponse.success) {
      setData(apiResponse.data);
      console.log(apiResponse.data);
    }
  }

  function renderTimeline() {
    let output = [];
    data
      ?.sort((a, b) => {
        return moment(a.createdOn) - moment(b.createdOn);
      })
      .forEach((timeline) => {
        if (timeline.type === 1) {
          output.push(
            <Timeline.Item dot={<CheckCircleOutlined />}>
              <div className="flex items-start justify-between">
                <div className="text-sm flex items-center gap-2">
                  <div>
                    {timeline.user?.imageUrl ? (
                      <Avatar src={timeline.user?.imageUrl} />
                    ) : (
                      <Avatar>
                        {timeline.user?.firstName?.charAt(0).toUpperCase() ||
                          "U"}
                      </Avatar>
                    )}
                  </div>
                  <div>
                    {timeline.user?.firstName
                      ? timeline?.user?.firstName +
                        " " +
                        timeline?.user?.lastName
                      : timeline.user?.username}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-gray-400">
                    {moment(timeline?.createdOn).format("DD.MM.YYYY")}
                  </div>
                  <Tag color="green" style={{ marginRight: "0" }}>
                    Added
                  </Tag>
                </div>
              </div>
            </Timeline.Item>
          );
        } else if (timeline.type === 2) {
          output.push(
            <Timeline.Item
              dot={
                <div className="text-red-500">
                  <CloseCircleOutlined />
                </div>
              }
            >
              <div className="flex items-start justify-between">
                <div className="text-sm flex items-center gap-2">
                  <div>
                    {timeline.user?.imageUrl ? (
                      <Avatar src={timeline.user?.imageUrl} />
                    ) : (
                      <Avatar>
                        {timeline.user?.firstName?.charAt(0).toUpperCase() ||
                          "U"}
                      </Avatar>
                    )}
                  </div>
                  <div>
                    {timeline.user?.firstName
                      ? timeline?.user?.firstName +
                        " " +
                        timeline?.user?.lastName
                      : timeline.user?.username}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-gray-400">
                    {moment(timeline?.createdOn).format("DD.MM.YYYY")}
                  </div>
                  <Tag style={{ marginRight: "0" }} color="red">
                    removed
                  </Tag>
                </div>
              </div>
            </Timeline.Item>
          );
        } else {
          output.push(
            <Timeline.Item>
              <div className="flex items-start justify-between">
                <div className="text-sm flex items-center gap-2">
                  <div>
                    {timeline.user?.imageUrl ? (
                      <Avatar src={timeline.user?.imageUrl} />
                    ) : (
                      <Avatar>
                        {timeline.user?.firstName?.charAt(0).toUpperCase() ||
                          "U"}
                      </Avatar>
                    )}
                  </div>
                  <div>
                    {timeline.user?.firstName
                      ? timeline?.user?.firstName +
                        " " +
                        timeline?.user?.lastName
                      : timeline.user?.username}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-gray-400">
                    {moment(timeline?.createdOn).format("DD.MM.YYYY")}
                  </div>
                  <Tag color="yellow" style={{ marginRight: "0" }}>
                    Changed
                  </Tag>
                </div>
              </div>
            </Timeline.Item>
          );
        }
      });
    return output;
  }
  return (
    <Modal
      title={"Position timeline"}
      visible={props.visible}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Timeline>{renderTimeline()}</Timeline>
      <div className="flex justify-between">
        <div></div>
        <Button onClick={props.handleCancel}>Ok</Button>
      </div>
    </Modal>
  );
}

export default PositionTimelineModal;
